export default __webpack_public_path__ + "static/O0149-9e1d01704d93cbe27df27979e52b0d4f.png";